import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './layout.component';

const routes: Routes = [
    {
        path: '',
        component: LayoutComponent,
        children: [
            { path: '', redirectTo: 'dashboard', pathMatch: 'prefix' },
            { path: 'dashboard', loadChildren: './dashboard/dashboard.module#DashboardModule' },
            { path: 'lugares', loadChildren: './lugares/lugares.module#LugaresModule' },
            { path: 'encs', loadChildren: './encs/encs.module#EncsModule' },
            /*{ path: 'forms', loadChildren: './form/form.module#FormModule' },
            { path: 'form2', loadChildren: './form2/form2.module#Form2Module' },
            { path: 'form3', loadChildren: './form3/form3.module#Form3Module' },
            { path: 'form4', loadChildren: './form4/form4.module#Form4Module' },*/
            { path: 'blank-page', loadChildren: './blank-page/blank-page.module#BlankPageModule' },
            { path: 'blank-page/:id', loadChildren: './blank-page/blank-page.module#BlankPageModule' },
            { path: 'instituciones', loadChildren: './instituciones/instituciones.module#InstitucionesModule' },
            { path: 'ciudadano', loadChildren: './ciudadano/ciudadano.module#CiudadanoModule' },
            { path: 'historial', loadChildren: './historial/historial.module#HistorialModule' },
            { path: 'historial/smartBand', loadChildren: './historial/historial.module#HistorialModule' },
            { path: 'historial/scale', loadChildren: './historial/historial.module#HistorialModule' },
            { path: 'pdf', loadChildren: './pdf/pdf.module#PdfModule' },
            { path: 'minimental', loadChildren: './mms/mms.module#MmsModule' },
            { path: 'blessed', loadChildren: './bls/bls.module#BlsModule' },
            { path: 'export', loadChildren: './export/export.module#ExportModule' },
            { path: 'earvi', loadChildren: './earvi/earvi.module#EarviModule' },
            { path: 'ucla', loadChildren: './ucla/ucla.module#UclaModule' },
            { path: 'esc', loadChildren: './esc/esc.module#EscModule' },
            { path: 'naci', loadChildren: './naci/naci.module#NaciModule' },
            { path: 'pnaci', loadChildren: './pnaci/pnaci.module#PnaciModule' },
            { path: 'escalasocial', loadChildren: './escalasocial/escalasocial.module#EscalaSocialModule' },
            { path: 'whoqol', loadChildren: './whoqol/whoqol.module#WhoqolModule' },
            { path: 'panas', loadChildren: './panas/panas.module#PanasModule' },
            { path: 'gds', loadChildren: './gds/gds.module#GdsModule'},
            ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class LayoutRoutingModule {}
